import { Heading } from '@chakra-ui/react';
export const CUIHeading = Heading;